import { IServiceProgramObject } from '../../../types/service-program'
import {
  SERVICE_PROGRAM_DELETE_FAIL,
  SERVICE_PROGRAM_DELETE_REQUEST,
  SERVICE_PROGRAM_DELETE_SUCCESS,
  SERVICE_PROGRAM_FAIL,
  SERVICE_PROGRAM_REQUEST,
  SERVICE_PROGRAM_SUCCESS,
  SERVICE_PROGRAM_UPDATE_FAIL,
  SERVICE_PROGRAM_UPDATE_REQUEST,
  SERVICE_PROGRAM_UPDATE_SUCCESS
} from '../../constants'
import { serviceProgramService } from '../../../services/ServiceProgram'

export interface IServiceProgramAction {
  type: string
}

export interface IServiceProgramListRequest extends IServiceProgramAction {}

export interface IServiceProgramListSuccess extends IServiceProgramAction {
  items: { [key: string]: IServiceProgramObject }
}

export interface IServiceProgramListFail extends IServiceProgramAction {
  error: string
}

export interface IServiceProgramDeleteRequest extends IServiceProgramAction {}

export interface IServiceProgramDeleteSuccess extends IServiceProgramAction {
  id: string
}

export interface IServiceProgramDeleteFail extends IServiceProgramAction {
  error: string
}

export interface IServiceProgramUpdateRequest extends IServiceProgramAction {}

export interface IServiceProgramUpdateSuccess extends IServiceProgramAction {
  item: IServiceProgramObject
}

export interface IServiceProgramUpdateFail extends IServiceProgramAction {
  error: string
}

export const fetchServicePrograms = () => (dispatch: any) => {
  dispatch(serviceProgramListRequest())
  serviceProgramService
    .getAll()
    .then(items => {
      dispatch(serviceProgramListSuccess(items))
      return items
    })
    .catch(error => {
      dispatch(serviceProgramListFail(error))
      throw error
    })
}

export const createServiceProgram = (name: string) => (dispatch: any) => {
  dispatch(serviceProgramUpdateRequest())
  return serviceProgramService
    .createOne(name)
    .then(item => dispatch(serviceProgramUpdateSuccess(item)))
    .catch(error => {
      dispatch(serviceProgramUpdateFail(error))
      throw error
    })
}

export const updateServiceProgram = (serviceProgram: IServiceProgramObject) => (dispatch: any) => {
  dispatch(serviceProgramUpdateRequest())
  return serviceProgramService
    .updateOne(serviceProgram)
    .then(item => dispatch(serviceProgramUpdateSuccess(item)))
    .catch(error => {
      dispatch(serviceProgramUpdateFail(error))
      throw error
    })
}

export const deleteServiceProgram = (id: string) => (dispatch: any) => {
  dispatch(serviceProgramDeleteRequest())
  return serviceProgramService
    .removeOne(id)
    .then(() => dispatch(serviceProgramDeleteSuccess(id)))
    .catch(error => {
      dispatch(serviceProgramDeleteFail(error))
      throw error
    })
}

export function serviceProgramListRequest(): IServiceProgramListRequest {
  return {
    type: SERVICE_PROGRAM_REQUEST
  }
}

export function serviceProgramListSuccess(items: { [key: string]: IServiceProgramObject }): IServiceProgramListSuccess {
  return {
    type: SERVICE_PROGRAM_SUCCESS,
    items
  }
}

export function serviceProgramListFail(error: string): IServiceProgramListFail {
  return {
    type: SERVICE_PROGRAM_FAIL,
    error
  }
}

export function serviceProgramDeleteRequest(): IServiceProgramDeleteRequest {
  return {
    type: SERVICE_PROGRAM_DELETE_REQUEST
  }
}

export function serviceProgramDeleteSuccess(id: string): IServiceProgramDeleteSuccess {
  return {
    type: SERVICE_PROGRAM_DELETE_SUCCESS,
    id
  }
}

export function serviceProgramDeleteFail(error: string): IServiceProgramDeleteFail {
  return {
    type: SERVICE_PROGRAM_DELETE_FAIL,
    error
  }
}

export function serviceProgramUpdateRequest(): IServiceProgramUpdateRequest {
  return {
    type: SERVICE_PROGRAM_UPDATE_REQUEST
  }
}

export function serviceProgramUpdateSuccess(item: IServiceProgramObject): IServiceProgramUpdateSuccess {
  return {
    type: SERVICE_PROGRAM_UPDATE_SUCCESS,
    item
  }
}

export function serviceProgramUpdateFail(error: string): IServiceProgramUpdateFail {
  return {
    type: SERVICE_PROGRAM_UPDATE_FAIL,
    error
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/service-program/service-program.ts